const doc = [({"da":({"js":({"admin":({"photo_types":({"select":({"choose_photo_type":"Vælg fototype"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;